<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-form-item label="账户类型：" prop="type">
        <dict dictName="account_type" v-model="dataForm.type" />
      </el-form-item>
      <el-form-item label="开户行名称：" prop="name">
        <el-input v-model="dataForm.name" size="mini" placeholder="请输入开户行名称"></el-input>
      </el-form-item>
      <el-form-item label="开户行账号：" prop="accountNo">
        <el-input
          v-model="dataForm.accountNo"
          placeholder="请输入开户行账号"
          size="mini"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="dataForm.remark"  size="mini" type="textarea" :rows="6" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {},
    };
  },
  computed: {
    dataRule() {
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        accountNo: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],

      };
    },
  },
  methods: {
    reset() {
      this.dataForm = {
        id:'',
        name: "",
        type: "银行账户",
        remark: "",
        accountNo: "",
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
        if (this.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/account/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },

    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let postForm = {
            ...this.dataForm,
          };
          this.$http[!postForm.id ? "post" : "put"]("/trade/account/", postForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    cancel() {
      this.visible = false;
    },
  },
};
</script>
